import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PayGroup } from '../shared/models/pay-group.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import urlJoin from 'url-join';
import { map } from 'rxjs/operators';
import { SettingsService } from '../shared/services/settings/settings.service';
import { ROUTE_TOKEN_GATEWAY_URL } from '../shared/interceptors/gateway-url.interceptor';

@Injectable()
export class PayGroupService {

  constructor(
    private http: HttpClient,
    private settings: SettingsService) { }

  getPayGroups(activeOnly: boolean = true): Observable<PayGroup[]> {
    // TODO: regenerate enums from SmartHub (remember [ToJs]) and use PayrollUnitStatus instead
    let params = new HttpParams();
    if (activeOnly) {
      params = params.append('status', '3'); // Active
    } else {
      params = params.append('status', null);
    }
    const url = this._getUri('paygroupcodes', this.settings.tenantId, params);
    return this.http.get<string[]>(url)
      .pipe(
        map(codes => codes.map(code => ({ code, name: code })))
      );
  }

  private _getUri(path: string, tenantId: string, params: HttpParams) {
    let uri = urlJoin(ROUTE_TOKEN_GATEWAY_URL, `payment/v1/tenants/${encodeURI(tenantId)}/payrollunits`, path);
    if (params) {
      uri += '?' + params.toString();
    }
    return uri;
  }
}
